<template>
    <div>
        <!-- accounts -->
        <div class="full-length-block" v-if="api_name == 'accounts'">
            <div class="content-code">
                <div class="bottomRight-request">
                <p>{{$t('ExampleRequest')}}</p>
                <p>{{$t('accounts')}}</p>
                </div>
                <div class="preload-bg">
                <div class="preloadURL">
                <p>{{$t('curlGET')}} <span ref="url_link_add">'http://server-address:port/api/v2/account/accounts?token=YoC1Buiy'</span></p>
                </div>
                <a href="#" @click.prevent="$parent.handleCopy($refs.url_link_add)" class="copyURL"><feather type="copy"></feather> </a>
                </div>
            </div>
            <div class="content">
                <div class="overflow-hidden content-section" id="content-get-started">
                    <div class="api-information">
                        <div class="folder-name"><p class="headTitle">{{$t('account')}}</p></div>
                        <div class="folder-description"></div>
                    </div>
                    <div class="api-information">
                        <div class="heading">
                        <div class="name addIcon">
                            <span class="GET method green" :title="$t('GET')">{{$t('GET')}}</span>
                            {{$t('account')}} <feather type="lock"></feather>
                            <span class="lock-icon"></span>
                        </div>
                        </div>
                        <div class="url">http://server-address:port/api/v2/account/accounts?token=YoC1Buiy</div>
                        <div class="description request-description">
                        <p>{{$t('GetAllAccounts')}}</p>
                        <div class="desc_code">
                            <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more)?'is-expandable':''">
                                <code class=" is-highlighted language-undefined">{
    "success": true,
    "message": "",
    "result": [
        {
            "AccountID": 100,
            "Balance": 100000000,
            "Currency": "USD",
            "UsedMargin": 0
        },
        {
            "AccountID": 1414,
            "Balance": 100000000,
            "Currency": "USD",
            "UsedMargin": 0
        },
        {
            "AccountID": 1415,
            "Balance": 100000000,
            "Currency": "EUR",
            "UsedMargin": 0
        },
        {
            "AccountID": 125,
            "Balance": 100000000,
            "Currency": "USD",
            "UsedMargin": 0
        }
    ]
}
                                </code>
                                
                            </pre>
                            <div class="expandMore">
                                  <a class="showMore-btn" v-if="!read_more" href="#" @click.prevent="read_more = true">{{$t('ReadMore')}}</a>  
                                  <a class="showLess-btn" v-if="read_more" href="#" @click.prevent="read_more = false">{{$t('ReadLess')}}</a>  
                                </div>
                        </div>
                        </div>
                        <div class="authorization-info" id="auth-info-">
                        <!-- <div class="heading"> <span class="auth-type"> PARAMS</span> </div> -->
                        </div> 
                        <div class="query-params">
                        <div class="heading">{{$t('sessionToken')}}</div>
                            <hr>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('token')}}</div>
                            <div class="value col-md-9 col-xs-12">YoC1Buiy</div>
                                <div class="description col-md-9 col-xs-12">
                                <p>{{$t('sessionToken')}}</p>
                                </div>
                            </div>
                        </div>  
                    </div> 
                </div>
            </div>
        </div>
        <!-- changepassword -->
        <div class="full-length-block" v-if="api_name == 'changepassword'">
            <div class="content-code">
                <div class="bottomRight-request">
                <p>{{$t('ExampleRequest')}}</p>
                <p>{{$t('changepass')}}</p>
                </div>
                <div class="preload-bg">
                <div class="preloadURL">
                <p>curl --location --request GET <span>'http://server-address:port/api/v2/account/changepassword?oldpassword=old&newpassword=new&token=aXiLklXq'</span></p>
                </div>
                </div>
            </div>
            <div class="content">
                <div class="overflow-hidden content-section" id="content-get-started">
                    <div class="api-information">
                        <div class="folder-name"><p class="headTitle">{{$t('account')}}</p></div>
                        <div class="folder-description"></div>
                    </div>
                    <div class="api-information">
                        <div class="heading">
                        <div class="name addIcon">
                            <span class="GET method green" :title="$t('GET')">{{$t('GET')}}</span>
                            {{$t('changepass')}} <feather type="lock"></feather>
                            <span class="lock-icon"></span>
                        </div>
                        </div>
                        <div class="url">http://server-address:port/api/v2/account/changepassword?oldpassword=old&newpassword=new&token=aXiLklXq</div>
                        <div class="description request-description">
                        </div>
                        <div class="authorization-info" id="auth-info-">
                        <div class="heading"> {{$t('AUTHORIZATION')}} <span class="auth-type"> {{$t('DigestAuth')}}</span> </div>
                        </div> 
                        <div class="query-params">
                        <div class="heading">{{$t('PARAMS')}}</div>
                            <hr>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('oldPass')}}</div>
                            <div class="value col-md-9 col-xs-12">{{$t('old')}}</div>
                                <div class="description col-md-9 col-xs-12">
                                <p>{{$t('oldPassword')}}</p>
                                </div>
                            </div>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('newpass')}}</div>
                            <div class="value col-md-9 col-xs-12">{{$t('new')}}</div>
                                <div class="description col-md-9 col-xs-12">
                                <p>{{$t('newPassword')}}</p>
                                </div>
                            </div>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('token')}}</div>
                            <div class="value col-md-9 col-xs-12">aXiLklXq</div>
                                <div class="description col-md-9 col-xs-12">
                                <p>{{$t('sessionToken')}}</p>
                                </div>
                            </div>
                        </div>  
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'account',
    props:['api_name'],
    data(){
        return {
            read_more : false
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_document/account.vue